// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import ManyToOneForm from '../../../../../Components/ManyToOneForm';
import FormCol from '../../../../../Components/FormCol';
import Material from '../../../../../Model/Material';
import StringForm from '../../../../../Components/StringForm';
import AnalyseMaterial from '../../../../../Model/AnalyseMaterial';

type Props = {
  material: AnalyseMaterial,
  index: number,
};

@observer
export default class AnalyseMaterialForm extends React.Component<Props, void> {

  render() {
    const { material } = this.props;
    return (
      <Card style={{ marginBottom: 16 }}>
        <CardBody>
          <Row>
            <FormCol wide>
              <ManyToOneForm
                entity={material}
                type={Material}
                field={'material'}
                title={'Material'}
              />
            </FormCol>
            <FormCol wide>
              <StringForm entity={material} field={'kommentar'} title={'Kommentar'} />
            </FormCol>
          </Row>
        </CardBody>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/View/AnalyseForm/MaterialTab/AnalyseMaterialForm.js